import { render, staticRenderFns } from "./BookingQuizComp_v2.vue?vue&type=template&id=162550e1"
import script from "./BookingQuizComp_v2.vue?vue&type=script&lang=ts"
export * from "./BookingQuizComp_v2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports